<div class="tweakstrength-bars">
  @for (tweakStrengthBar of tweakStrengthBars; track tweakStrengthBar; let i = $index) {
    <div
      class="tweakstrength-bar {{ statusClass }}"
      [class.selected]="tweakStrengthBar.selected"
    ></div>
  }
</div>
